import { LogoAwsColored } from "components/icons/generated";
import IconEmphasized from "ds/components/IconEmphasized";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { AwsIntegrationView } from "../../../useSearchCloudIntegrations/gql";
import styles from "./styles.module.css";

const IntegrationsAwsTableTypeCell = ({
  ...cellProps
}: TableSimpleCellProps<AwsIntegrationView>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <IconEmphasized className={styles.typeIcon} icon={LogoAwsColored} />
    </TableSimpleCell>
  );
};

export default IntegrationsAwsTableTypeCell;
